// Generated from build58 src/features/musicEdition/motion.ts; do not edit.
// Each scene has its own editorial rhythm, not a whole-card fade. No loops,
// random motion or non-final numbers are exported.
export const editionMotionDuration = {
  cover: 820,
  card: 700,
  stars: 950,
  genres: 760,
  artist: 880,
  quote: 900,
  divergence: 720,
  discovery: 760,
  seasons: 900,
  words: 860,
  festival: 980,
  persona: 800,
  quiz: 800,
  duet: 860,
};
export function editionMotion(scene, progress, index = 0) {
  if (progress >= 1) return { opacity: 1, transform: 'translate(0 0)' };
  const stagger =
    scene === 'festival' ? 0.13 : scene === 'seasons' || scene === 'words' ? 0.12 : 0.055;
  const start = Math.min(0.72, Math.max(0, Math.min(index, 8)) * stagger);
  const local = Math.max(0, Math.min(1, (progress - start) / Math.max(0.24, 1 - start)));
  const eased = 1 - (1 - local) ** 3;
  const x = scene === 'genres' || scene === 'duet' ? (index % 2 ? 14 : -14) * (1 - eased) : 0;
  const y = ['cover', 'card', 'artist', 'seasons', 'words', 'festival', 'quiz'].includes(scene)
    ? 16 * (1 - eased)
    : 0;
  return { opacity: eased, transform: `translate(${x} ${y})` };
}
